export enum FormActionEntityState {
  disabled = 'disabled',
  enabled = 'enabled',
}

export type FormActionsEntityApi = {
  /** Надпись на кнопке */
  title: string;
  /** Обозначение действия */
  kind: string;
  state: FormActionEntityState;
  extra: Record<
    string,
    unknown
  > /* todo: Заполнить структуру, когда её поддержат на бэке  */;
};

export type FormActionsEntity = FormActionsEntityApi;
